import { useEffect, useState, useCallback, createContext, useContext } from 'react';
import { routes } from '../../options/routes';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
// Helpers
import { getClubPlayersList } from '../../utils/helpers/getClubPlayersList';

import
{
  getNewPlayerStats,
} from '../../utils/helpers/indexStatsHelpers';

// API calls
import
{
  getLatestProgrammeStats,
  getClubPlayers,
  getDrillSummaryStats,
  getClubPlayerProfile,
  getBoardsClubDrills,
  getGlobalLeaderBoardStats,

  getBoardsRezzilIndex,

} from '../../api';

// Contexts
import { BaseContext } from '../Global/BaseProvider';

import { createPlayerStatsObject, createDrillStatsProgrammes } from '../../utils/helpers/drillStatsHelper';
const PrintStatsContext = createContext({});

const PrintStatsProvider = ({ children }) =>
{
  const baseContext = useContext(BaseContext);
  const [indexStatsData, setIndexStatsData] = useState({});
  const [drillStatsData, setDrillStatsData] = useState({
    playerStats: null,
    apiError: false,
  });

  const params = useParams();
  const getDrillStatsData = useCallback(async () =>
  {

    // Only trigger API call for drillStats route
    const activeRoute = window.location.pathname;
    //  if (activeRoute !== routes.indexPrintStats) return;

    // Call API
    if (!baseContext.baseData.loading && !drillStatsData.loading)
    {
      setDrillStatsData({ loading: true });
      const { userProfile, clubProfile } = baseContext.baseData;
      const clubData = await getClubPlayers(clubProfile.id);

      if (!clubData || !clubData.success || !clubData.data)
      {
        setDrillStatsData({
          loading: false,
          playerStats: null,
          clubProfiles: null,
          allProgrammeSessions: [],
          drillStats: null,
          apiError: true,
          allLoaded: true,
        });
        return;
      }

      // Check if userProfile id is in the current club data
      const { profiles } = clubData.data;


      // Call club best drills API
      // const playerStatsId = profiles.length ? (profiles.find((profile) => profile.id === userProfile.id)) ? userProfile.id : profiles[0].id : undefined;
      const playerStatsId = params.playerId;

      const clubLeaderboard = await getBoardsClubDrills(clubProfile.id);
      const globalLeaderboard = await getGlobalLeaderBoardStats();
      const { drillStats, allProgrammeSessions } = await createDrillStatsProgrammes(playerStatsId);
      console.log('nps1', drillStats, allProgrammeSessions)

      if (!profiles.length)
      {
        setDrillStatsData({
          loading: false,
          playerStats: createPlayerStatsObject(
            {},
            {},
            clubLeaderboard?.data,
            globalLeaderboard?.data,
            {}
          ),
          clubProfiles: [],
          drillStats,
          allProgrammeSessions: [],
          clubLeaderboard: clubLeaderboard?.data,
          globalLeaderboard: globalLeaderboard?.data,
          apiError: false,
          allLoaded: true,
        });
        return;
      }

      const latestPlayerStatsData = await getLatestProgrammeStats(playerStatsId);

      const profileData = await getClubPlayerProfile(playerStatsId);
      const drillAverageStats = await getDrillSummaryStats(playerStatsId);


      if (
        !latestPlayerStatsData ||
        !latestPlayerStatsData.success ||
        !latestPlayerStatsData.data ||
        !profileData ||
        !profileData.success ||
        !profileData.data ||
        !drillAverageStats ||
        !drillAverageStats.success ||
        !drillAverageStats.data
      )
      {
        setDrillStatsData({
          loading: false,
          playerStats: null,
          clubProfiles: null,
          drillStats: null,
          apiError: true,
          allLoaded: true,
        });
      }

      const tempPlayerStatsData = createPlayerStatsObject(
        profileData?.data,
        drillAverageStats?.data,
        clubLeaderboard?.data,
        globalLeaderboard?.data,
        latestPlayerStatsData.data
      );
      // Set data
      setDrillStatsData({
        loading: false,
        playerStats: tempPlayerStatsData,
        clubProfiles: clubData.data.profiles,
        drillStats,
        allProgrammeSessions,
        clubLeaderboard: clubLeaderboard?.data,
        globalLeaderboard: globalLeaderboard?.data,
        apiError: false,
        allLoaded: true,
      });
    }

  }, [baseContext]);

  const getIndexStatsData = useCallback(async () =>
  {
    // Only trigger API call for indexStats route
    const activeRoute = window.location.pathname;
    if (activeRoute !== routes.indexPrintStats)
    {

      //  return;
    }

    // Call API
    // (activeRoute === routes.indexStats && ) && 
    if (!baseContext.baseData.loading && !indexStatsData.loading)
    {
      setIndexStatsData({ loading: true });
      // Set score variables
      let playerProfiles = null,
        allProgrammeSessions = null,
        allProgrammeSessionsDeep = null,
        playerStats = null,
        worldAvgStats = null,
        programmeSessionStats = null,
        indexBreakdownData = null;
      const { id } = baseContext.baseData.clubProfile;
      const clubRezzilIndexData = await getBoardsRezzilIndex(id);
      const globalRezzilIndexData = await getGlobalLeaderBoardStats();
      // Call club player profiles API
      const playerProfilesData = await getClubPlayers(id);
      if (
        !playerProfilesData ||
        !playerProfilesData.success ||
        playerProfilesData.code !== 200 ||
        !clubRezzilIndexData ||
        !clubRezzilIndexData.success ||
        clubRezzilIndexData.code !== 200 ||
        !globalRezzilIndexData ||
        !globalRezzilIndexData.success ||
        globalRezzilIndexData.code !== 200
      )
      {
        setIndexStatsData({
          loading: false,
          playerProfiles,
          allProgrammeSessions,
          allProgrammeSessionsDeep,
          playerStats,
          worldAvgStats,
          programmeSessionStats,
          indexBreakdownData,
          apiError: true,
          allLoaded: true,
        });
        return;
      }
      // Get playerProfiles from playerProfilesData
      const { profiles } = playerProfilesData.data;
      playerProfiles = getClubPlayersList(profiles);

      const clubLeaderboard = clubRezzilIndexData.data.leaderboard.scores;
      const globalLeaderboard = globalRezzilIndexData.data.leaderboards.rezzil_index.scores;

      // Get logged in player stats if in playerProfiles


      const initialPlayerId = params.playerId;;
      // if (loggedInPlayerInChoicesById(loggedInPlayerId, playerProfiles)) {
      // Make relevant API calls to get data
      if (indexStatsData?.playerStats?.rezzilId !== initialPlayerId)
      {
        const { success, newPlayerStats } = await getNewPlayerStats(initialPlayerId, clubLeaderboard, globalLeaderboard);
        console.log('nps2', newPlayerStats)
        if (!success)
        {
          setIndexStatsData({
            loading: false,
            playerProfiles,
            allProgrammeSessions,
            allProgrammeSessionsDeep,
            playerStats,
            worldAvgStats,
            programmeSessionStats,
            indexBreakdownData,
            apiError: true,
            allLoaded: true,
          });
          return;
        }

        allProgrammeSessions = newPlayerStats.allProgrammeSessions;
        allProgrammeSessionsDeep = newPlayerStats.allProgrammeSessionsDeep;
        playerStats = newPlayerStats.playerStats;
        worldAvgStats = newPlayerStats.worldAvgStats;
        programmeSessionStats = newPlayerStats.programmeSessionStats;
        indexBreakdownData = newPlayerStats.indexBreakdownData;

        setIndexStatsData({
          loading: false,
          playerProfiles,
          allProgrammeSessions,
          allProgrammeSessionsDeep,
          playerStats,
          worldAvgStats,
          programmeSessionStats,
          indexBreakdownData,
          clubLeaderboard,
          globalLeaderboard,
          apiError: false,
          allLoaded: true,
        });
      }
    }
  }, [baseContext]);

  useEffect(() =>
  {
    getIndexStatsData(); getDrillStatsData();
  }, [getIndexStatsData, getDrillStatsData]);

  return (
    <PrintStatsContext.Provider
      value={{
        indexStatsData,
        getIndexStatsData,
        drillStatsData,
        getDrillStatsData
      }}
    >
      {children}
    </PrintStatsContext.Provider>
  );
}

export { PrintStatsProvider, PrintStatsContext };

export default PrintStatsProvider;
